import { StoreType } from '@tock/shared/utils/connect';
import BaseComponent from '@tock/shared/components/BaseComponent';
import SectionHeader from 'components/SectionHeader';
import TransferRecipientForm from 'forms/transfer/TransferRecipientForm';
import uiFlowComponent, { FlowProps } from 'components/ui-flow/uiFlowComponent';

export interface Props {
  onSetTransferTo(email: string): void;
  transfer: StoreType['transfer'];
}

class TransferRecipientRoute extends BaseComponent<Props & FlowProps> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit(data: any) {
    this.props.onSetTransferTo(data.email);
    this.props.history.push(this.props.nextRoute);
  }

  render() {
    return (
      <div className="MainContent">
        <div className="SectionWrapper">
          <div className="SectionContent">
            <SectionHeader
              heading="Select a recipient"
              subheading="Enter the email address of the recipient of this transfer."
            />
            <TransferRecipientForm onSubmit={this.handleSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default uiFlowComponent(TransferRecipientRoute);
